export const ACCOUNTS_REQUESTED = 'ACCOUNTS_REQUESTED'
export const ACCOUNTS_RECEIVED = 'ACCOUNTS_RECEIVED'
export const BANK_ACCOUNT_SELECTED = 'BANK_ACCOUNT_SELECTED'
